import type { ExchangeRatesResult } from '@/types';
import { ApiError } from '@/features/bet-inspection/lib/api';

/** GET {api}/exchange-rates — game_aggr.exchange_rates as stored. Not project-scoped. */
export async function fetchExchangeRates(params: {
  api: string;
  token: string | null;
  signal?: AbortSignal;
}): Promise<ExchangeRatesResult> {
  const base = params.api.replace(/\/+$/, '');

  let res: Response;
  try {
    res = await fetch(`${base}/exchange-rates`, {
      headers: params.token ? { authorization: `Bearer ${params.token}` } : {},
      signal: params.signal,
    });
  } catch (err) {
    if ((err as Error)?.name === 'AbortError') throw err;
    throw new ApiError(`Could not reach the betlens API at ${base}.`, 0);
  }

  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new ApiError(body?.error ?? `Request failed (${res.status})`, res.status);
  }

  return (await res.json()) as ExchangeRatesResult;
}
